import { Component } from './alert.component'
import { ContextProvider, useAlert } from './alert.context'

export const Alert = {
  Component: Component,
  Hook: useAlert,
  Provider: ContextProvider,
}
